import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-white hover:bg-destructive/80",
        outline: "text-foreground",
        info: "border-transparent bg-info text-white hover:bg-info/80",
        success: "border-transparent bg-success text-white hover:bg-success/80",
        warning: "border-transparent bg-warning text-white hover:bg-warning/80",
        error: "border-transparent bg-error text-white hover:bg-error/80",
        primaryLight:
          "border-transparent bg-primary-light text-white hover:bg-primary-light/80 dark:text-black",
        primaryDark:
          "border-transparent bg-primary-dark text-white hover:bg-primary-dark/80",
        secondaryLight:
          "border-transparent bg-secondary-light text-white hover:bg-secondary-light/80",
        secondaryDark:
          "border-transparent bg-secondary-dark text-white hover:bg-secondary-dark/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
